<template>
  <div class="export-dialog">
    <Dialog :maskClose="true" :dialogShow="show" :title="titleMap[type] + '导出（已选择 ' + currentSelectedIds.length + ' 条数据）'" @maskClick="maskClick">
      <template>
        <el-table
          ref="exportTable"
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          empty-text="暂无数据"
          @select="selectTable"
          @select-all="selectTable"
          :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
          :row-key="row => row.id"
          height="400"
        >
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column prop="name" label="店铺名称"></el-table-column>
          <el-table-column prop="refId" label="内部店铺编号"></el-table-column>
        </el-table>
      </template>
      <div class="dialog-button-div">
        <el-button type="default" class="cancel" @click="maskClick">取消</el-button>
        <el-button type="primary" :loading="loading" class="determine" @click="onExport">导出</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog/index";
import { api_postStoredcardExport, api_postStoredVCCodeExport } from '@/api/finance'
import { downFile } from "@/utils";

export default {
  name: "exportDialog",
  components: {
    Dialog
  },
  props: {
    show: Boolean,
    type: String,
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
    selectedIds: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      loading: false,
      titleMap: {
        "cardBuyRecord": "购卡记录",
        "cardScanCode": "储值卡推广码",
      },
      currentSelectedIds: [],
      currentSelectedData: [],
    };
  },
  created() {
  },
  methods: {
    // 表格选择
    selectTable(selection) {
      this.currentSelectedData = selection
      this.currentSelectedIds = selection.map(item => item.id)
    },


    // 点击导出按钮
    onExport() {
      if (this.currentSelectedIds.length == 0){
        this.$baseMessage('请选择需要导出的数据', 'error')
        return
      }

      if (this.type == 'cardBuyRecord') {
        this.exportCardRecords()
      } else if (this.type == 'cardScanCode') {
        this.exportCardScanCode()
      }
    },

    // 导出购卡记录
    async exportCardRecords() {
      this.loading = true
      let newarr = this.currentSelectedIds.filter(item => item);
      const params = {
        storeIds: newarr
      }
      let res = await api_postStoredcardExport(params)
      downFile(res)
      this.loading = false
      this.maskClick()
    },

    // 储值卡推广码导出
    async exportCardScanCode() {
      this.loading = true
      try {
        let newarr = this.currentSelectedIds.filter(item => item);
        const params = {
          storeIds: newarr.join(',')
        }
        let res = await api_postStoredVCCodeExport(params)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        let fileName = res.headers['content-disposition'].split('filename=')[1]
        fileName = decodeURI(fileName)
        const link = document.createElement('a')
        link.target = '_blank'
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
        this.maskClick()
      } catch (err) {
        this.$baseMessage('下载失败', 'error')
        console.log('err: ', err);
      }
      this.loading = false
    },

    maskClick() {
      this.loading = false
      this.$emit('close')
    }
  },
  watch: {
    selectedIds(newValue) {
      this.currentSelectedIds = newValue
    },
    show(newValue) {
      if (newValue && this.currentSelectedIds.length) {
        setTimeout(() => {
          this.currentSelectedIds = this.tableData.map(item => item.id)
          this.tableData.forEach(item => {
            this.$refs.exportTable.toggleRowSelection(item, true);
          })
        }, 300)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .export-dialog {

    .dialog-button-div {
      padding-top: 20px;
      text-align: right;
    }
  }
</style>
